import React from "react";
import style from "./header.module.css";

const Header = () => {
  return (
    <div className={style.header}>
      <h1>Todos App</h1>
    </div>
  );
};

export default Header;
